<template>
  <div class="page">
    <div class="container-div">
      <ion-grid>
        <!-- <ion-row class="row-divider"></ion-row> -->
        <ion-row class="rectangle-chart">
          <ion-col size="12" size-md="12" size-lg="6" size-xs="12" class="chart-column">
            <canvas id="myChart1" class="my-chart"></canvas>
            <p class="noAssociatedStations" v-if="!noStationAssociatedInd && !displayInd" style="text-align: center;">No Associated Stations</p>
          </ion-col>
          <ion-col size="12" size-md="12" size-lg="6" size-xs="12" class="status-divider status-column" v-if="displayInd">
            <div class="status-info" >
              <ion-row>
                <ion-col><h2 style="text-align: center;">Charger Status</h2></ion-col>
              </ion-row>
                <ion-row>
                  <ion-col
                    v-for="(item, index) in statusConfig"
                    :key="index"
                    size="12"
                    size-sm="6"
                    size-md="6"
                    size-lg="6"
                    class="charger-status"
                    @click="navigateStatusList(item.label)"
                  >
                    <div class="status-card">

                      <div
                        class="status-circle"
                        :style="{ backgroundColor: item.color }"
                      ></div>

                      <div class="status-content">

                        <div
                          class="status-title"
                          :style="{ color: item.color }"
                        >
                          {{ item.label }}: <span class="status-count">{{ chargerStatusData.displayData[item.key] }}</span> 
                        </div>
                        <!-- <br/> -->
                        <!-- <div class="status-count">
                          {{ chargerStatusData.displayData[item.key] }}
                        </div> -->

                      </div>

                    </div>
                  </ion-col>
                </ion-row>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
    <div class="spinner">
      <ion-spinner v-if="loaderTab"></ion-spinner>
    </div>
  </div>
</template>


<script>
import { defineComponent } from "vue";
import { refresh,flash, closeCircle, batteryCharging, radio , hardwareChip, people, pieChart } from 'ionicons/icons';
import Chart from "chart.js/auto";
import { CorporateService } from "../../service/corporate/corporate.service";
import { IonButton, IonRow, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonSelect, IonSelectOption, IonSpinner } from "@ionic/vue";
import { ToastUtils } from "../../util/toast-utils";
import { migratedTryParseServiceError } from "../../service";

const centerTextPlugin = {
  id: 'centerText',
  beforeDraw(chart) {
  const { ctx } = chart;

  const text = chart.config.options.plugins?.centerText?.text;

  if (!text) return;

  // Get actual doughnut center
  const meta = chart.getDatasetMeta(0);

  if (!meta.data.length) return;

  const centerX = meta.data[0].x;
  const centerY = meta.data[0].y;

  ctx.save();

  ctx.font = "bold 20px Arial";
  ctx.fillStyle = "#000";
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";

  if (Array.isArray(text)) {
  const lineHeight = 20;

  text.forEach((line, index) => {
    ctx.fillText(
      line,
      centerX,
      centerY + (index - (text.length - 1) / 2) * lineHeight
    );
  });
} else {
  ctx.fillText(text, centerX, centerY);
}

  ctx.restore();
}
};

Chart.register(centerTextPlugin);

export default defineComponent ({
  name: 'chargerStatusDashboard',
  components: {
    IonGrid, IonRow, IonCol, IonLabel, IonSelect, IonSelectOption, IonInput, IonButton, IonIcon, IonSpinner
  },
  props: {
    chartData : {type: Object}
  },
  
  data() {
    return {
      flash,
      closeCircle,
      batteryCharging,
      hardwareChip,
      radio ,
      people,
      pieChart,
      statusConfig: [
        {
          label: "Available",
          key: "availableCount",
          icon: flash,
          color: "#16a34a"
        },
        {
          label: "Unavailable",
          key: "unavailableCount",
          icon: closeCircle,
          color: "#ef4444"
        },
        {
          label: "Occupied",
          key: "occupiedCount",
          icon: batteryCharging,
          color: "#f59e0b"
        },
        {
          label: "Connected",
          key: "connectedCount",
          icon: radio ,
          color: "#2563eb"
        },
        {
          label: "Faulted",
          key: "faultedCount",
          icon: pieChart,
          color: "#7c3aed"
        },
        {
          label: "ThirdParty",
          key: "thirdPartyCount",
          icon: people,
          color: "#6b7280"
        },
        
      ],
      refresh,
      chartTypes: [{'name' : 'Charger Status'},{"name" : "Admin Dashboard"}],
      chartName: "",
      // branchId: "",
      chartTypeInd: true,
      doughnutChartInd: true,
      myChart1: null,
      chargerStatusData: "",
      displayInd: false,
      loaderTab: false,
      noStationAssociatedInd: true,
      displayLineChart1: false,
      displayLineChart2: false,
      displayLineChart3: false,
      displayLineChart4: false,
      displayChargerStatus: false,
      displayFenfeoAdminChart: false,
      chargerCurrentStatusChart: null,
      dailyUsageBarChart: null,
      greenHousGasData: null,
      customerVisitCountData: null,
      transactionCountData: null,
      revenueCountData: null
    }
  },
  async mounted() {
    this.displayChargerStatus = true;
    this.chargerStatusData = this.chartData;
   
    if(this.chargerCurrentStatusChart) {
      this.chargerCurrentStatusChart.destroy();
      this.chargerCurrentStatusChart = null;
    }
    this.chargerStatusChart(this.chartData)
  },
  methods: {
    chargerStatusChart(chargerStatusData) {
      let chartData = chargerStatusData;
      this.statusConfig.forEach((item) => {
        const index = chartData.chartLabel.indexOf(item.label);
        item.color = chartData.chartColor[index];
      });
      this.displayInd = true;
      try {
        var ctx = document.getElementById('myChart1');
        const existingChart = Chart.getChart(ctx);
        if (existingChart) {
          existingChart.destroy();
        }

        const totalCount = chartData.displayData.totalCount;
        this.chargerCurrentStatusChart = new Chart(ctx, {
          type: 'doughnut',
          data: {
            labels: chartData.chartLabel,
            datasets: [{
              data: chartData.chartData,
              backgroundColor: chartData.chartColor
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: true,
            plugins: {
              datalabels: {
                display: false
              },
              tooltip: {
                enabled: false
              },
              labels: {
                display: false
              },
              customPlugin: {
                display: false
              },
              legend: {
                display: false
                  // color: 'black'   // label color black
              },
              // labels: {
              //   render:()=>{},
              //   precision: 0,
              //   showZero: true,
              //   fontSize: 76,
              //   fontColor: '#fff',
              //   fontStyle: 'normal',
              //   textShadow: true,
              //   shadowBlur: 10,
              //   shadowOffsetX: 5,
              //   shadowOffsetY: 5,
              //   shadowColor: 'grey',
              //   arc: false,
              //   position: 'default',
              //   overlap: true,
              //   showActualPercentages: false,
              // },
             centerText: {
              text: ["Total", String(totalCount)]
            }
            },
            
            onClick: (event, elements) => {
              try {
                if (!elements.length) return;

                const index = elements[0].index;
                const label = chartData.chartLabel[index];

                this.navigateStatusList(label);
              //   var label = e.chart.tooltip.dataPoints[0].label;
              //   this.navigateStatusList(label)
                // localStorage.setItem('branchIDFromDashboard', this.branchId);
                // localStorage.setItem('branchPage', 1);
                // if(label == 'Available') {
                //   localStorage.setItem('chargerStatusData', JSON.stringify(this.chargerStatusData.available) )
                //   localStorage.setItem('dataType', "Available")
                //   this.$router.push("/admin/chargerStatusList");
                // } else if(label == 'Unavailable') {
                //   localStorage.setItem('chargerStatusData', JSON.stringify(this.chargerStatusData.unavailable))
                //   localStorage.setItem('dataType', "Unavailable")
                //   this.$router.push("/admin/chargerStatusList");
                // } else if(label == 'Occupied') {
                //   localStorage.setItem('chargerStatusData', JSON.stringify(this.chargerStatusData.occupied))
                //   localStorage.setItem('dataType', "Occupied")
                //   this.$router.push("/admin/chargerStatusList");
                // } else if(label == 'Connected') {
                //   localStorage.setItem('chargerStatusData', JSON.stringify(this.chargerStatusData.connected))
                //   localStorage.setItem('dataType', "Connected")
                //   this.$router.push("/admin/chargerStatusList");
                // } else if(label == 'ThirdParty') {
                //   localStorage.setItem('chargerStatusData', JSON.stringify(this.chargerStatusData.thirdParty))
                //   localStorage.setItem('dataType', "ThirdParfty")
                //   this.$router.push("/admin/chargerStatusList");
                // }
              } catch(error) {
                console.log(error)
              }
              
            }
          }
        });
      } catch(error) {
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
    },
    navigateStatusList(label) {
      try {
        // localStorage.setItem('branchIDFromDashboard', this.branchId);
        localStorage.setItem('branchPage', 1);
        if(label == 'Available') {
          localStorage.setItem('chargerStatusData', JSON.stringify(this.chargerStatusData.available) )
          localStorage.setItem('dataType', "Available")
          if(this.chargerStatusData.displayData.availableCount > 0) {
            this.$router.push("/admin/chargerStatusList");
          }
          
        } else if(label == 'Unavailable') {
          localStorage.setItem('chargerStatusData', JSON.stringify(this.chargerStatusData.unavailable))
          localStorage.setItem('dataType', "Unavailable")
          if(this.chargerStatusData.displayData.unavailableCount > 0) {
            this.$router.push("/admin/chargerStatusList");
          }
          
        } else if(label == 'Occupied') {
          localStorage.setItem('chargerStatusData', JSON.stringify(this.chargerStatusData.occupied))
          localStorage.setItem('dataType', "Occupied")
          if(this.chargerStatusData.displayData.occupiedCount > 0) {
            this.$router.push("/admin/chargerStatusList");
          }
          
        } else if(label == 'Connected') {
          localStorage.setItem('chargerStatusData', JSON.stringify(this.chargerStatusData.connected))
          localStorage.setItem('dataType', "Connected")
          if(this.chargerStatusData.displayData.connectedCount > 0) {
            this.$router.push("/admin/chargerStatusList");
          }
          
        } else if(label == 'Faulted') {
          localStorage.setItem('chargerStatusData', JSON.stringify(this.chargerStatusData.faulted))
          localStorage.setItem('dataType', "Faulted")
          if(this.chargerStatusData.displayData.faultedCount > 0) {
            this.$router.push("/admin/chargerStatusList");
          }
        } else if(label == 'ThirdParty') {
          localStorage.setItem('chargerStatusData', JSON.stringify(this.chargerStatusData.thirdParty))
          localStorage.setItem('dataType', "ThirdParfty")
          if(this.chargerStatusData.displayData.thirdPartyCount > 0) {
            this.$router.push("/admin/chargerStatusList");
          }
        }
      } catch(error) {
        console.log(error)
      }
    }
  }
})

</script>

<style scoped>
.container-div {
  margin: 2px 25px 0px 25px;
}

.rectangle-chart {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
  padding: 5px;
  align-items: stretch;
}

.chart-column {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 420px;
  position: relative;
}

.my-chart {
  width: 100% !important;
  max-width: 350px;
  height: 350px !important;
  display: block;
  margin: 0 auto;
}

.status-column {
  display: flex;
  align-items: center;
}

.status-divider {
  border-left: 2px solid #e5e7eb;
}

.status-info {
  width: 100%;
  padding: 20px 30px;
}

.status-heading {
  text-align: center;
  margin-bottom: 15px;
}

.charger-status {
  padding: 8px;
  margin-top: 10px;
  cursor: pointer;
}

.status-card {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 16px;
  background: #fff;
  border: 1px solid #ececec;
  border-radius: 14px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, .08);
  transition: 0.3s;
}

.status-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, .12);
}

.status-circle {
  width: 16px;
  height: 16px;
  border-radius: 3px;
  flex-shrink: 0;
}

.status-content {
  flex: 1;
}

.status-title {
  font-size: 16px;
  font-weight: 600;
  word-break: break-word;
}

.status-count {
  font-size: 16px;
  font-weight: bold;
}

.bullet-dotted {
  width: 13px;
  height: 13px;
  display: inline-block;
  border-radius: 2px;
}

.noStations,
.noStations1,
.noAssociatedStations {
  text-align: center;
  font-weight: bold;
  margin-top: 20px;
}

.l-c1,
.l-c2,
.l-c3,
.l-c4 {
  border: 1px solid lightgrey;
  margin: 2px;
  background: #ebebeb;
}

.btn-refresh {
  text-align: center !important;
  margin-left: 40px;
  font-family: "Roboto";
  font-size: 1.5rem;
  color: #fff;
  height: 40px;
  border-radius: 3px;
  --background: #e1899c;
  --background-focused: #b4b2b2;
  --background-hover: #b4b2b2;
  --webkit-background-focused: #b4b2b2;
  --webkit-background-hover: #b4b2b2;
}

.barChart1 {
  height: 370px !important;
}

.chart-label {
  margin: 0;
  padding: 0;
  text-align: center;
}

.display-value {
  margin: 0;
  padding: 0;
  font-weight: bold;
  text-align: left;
}

   /* Large Tablet */

@media (max-width: 991px) {

  .container-div {
    margin: 10px 15px;
  }

  .chart-column {
    min-height: 350px;
  }

  .my-chart {
    max-width: 350px;
    height: 350px !important;
  }

  .status-divider {
    border-left: none;
    border-top: 2px solid #e5e7eb;
    margin-top: 20px;
    padding-top: 20px;
  }

  .status-info {
    padding: 20px;
  }
}


   /* Mobile */


@media (max-width: 576px) {

  .container-div {
    margin: 8px;
  }

  .rectangle-chart {
    padding: 8px;
  }

  .chart-column {
    min-height: 280px;
  }

  .my-chart {
    width: 100% !important;
    max-width: 260px;
    height: 260px !important;
  }

  .status-info {
    padding: 10px;
  }

  .charger-status {
    padding: 5px;
    margin-top: 8px;
  }

  .status-card {
    padding: 15px;
    gap: 10px;
  }

  .status-circle {
    width: 14px;
    height: 14px;
  }

  .status-title {
    font-size: 14px;
  }

  .status-count {
    font-size: 16px;
  }

  .btn-refresh {
    width: 100%;
    margin-left: 0;
    font-size: 1rem;
  }
}

   /* Extra Small Devices */

@media (max-width: 360px) {

  .my-chart {
    max-width: 220px;
    height: 220px !important;
  }

  .status-title {
    font-size: 13px;
  }

  .status-count {
    font-size: 15px;
  }

  .status-card {
    padding: 15px;
  }
}

</style>